<template>
    <div>
        <div class="d-flex justify-content-center mb-3">
            <ul class="nav nav-pills">
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'planos' ? 'active' : ''" @click.prevent="abrir('planos')">
                        Plano de Contas
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'contas' ? 'active' : ''" @click.prevent="abrir('contas')">
                        Contas
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'vinculo' ? 'active' : ''" @click.prevent="abrir('vinculo')">
                        Vínculo
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'lancamentos' ? 'active' : ''" @click.prevent="abrir('lancamentos')">
                        Lançamentos
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'baixas' ? 'active' : ''" @click.prevent="abrir('baixas')">
                        Baixas
                    </a>
                </li>
                <li class="nav-item">
                    <div class="btn-group dropleft">
                        <button class="btn btn-light dropdown-toggle" type="button" id="triggerId" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fas fa-ellipsis-h ml-2"></i>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="triggerId">
                            <a class="dropdown-item" href="#" :class="aba == 'layouts' ? 'active' : ''" @click.prevent="abrir('layouts')">
                                Layouts
                            </a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <plano-contabil v-if="aba == 'planos'" />
        <conta-contabil v-else-if="aba == 'contas'" />
        <vinculo-contabil v-else-if="aba == 'vinculo'" />
        <lancamento :block_redir="true" :view="true" v-else-if="aba == 'lancamentos'" />
        <extrato-de-contas :block_redir="true" :view="true" v-else-if="aba == 'baixas'" />
        <cadastro-layout-exportacao v-else-if="aba == 'layouts'" />

        <pre v-else>{{ aba }}</pre>

    </div>
</template>

<script>
import PlanoContabil from './PlanoContabil.vue';
import ContaContabil from './ContaContabil.vue';
import VinculoContabil from './VinculoContabil.vue';
import Lancamento from '../financeiro/Lancamento.vue';
import ExtratoDeContas from '../financeiro/ExtratoDeContas.vue';
import CadastroLayoutExportacao from '../../cadastros/items/CadastroLayoutExportacao.vue';

export default {
    data() { 
        return { 
            fluxo: null, 
        };
    },

    components: { 
        PlanoContabil,
        ContaContabil, 
        VinculoContabil,
        Lancamento, 
        ExtratoDeContas, 
        CadastroLayoutExportacao,
    }, 

    props: ['aba'], 

    methods: { 
        estado(fluxo) { 
            this.fluxo = fluxo;
        },

        abrir(aba) { 
            if ( aba != this.aba ) { 
              this.$router.push({ path: '/contabilidade/' + aba });
            }
        },
    },
}
</script>